import CommonValidation from '../../../../utils/common.validation';

class Validation {
  static formValidate = (type, value) => {
    switch (type) {
      case 'serviceTypeCode':
      case 'holidayTypeCode':
        return CommonValidation.requiredSelect(value);
      case 'startDate':
      case 'endDate':
        return CommonValidation.requiredDate(value);
      default:
        return '';
    }
  };
}

export default Validation;
